import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  TransportationMode,
  TransportationModeValues,
  ValuesMobility,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionMobilityDto } from './dto.type';

export class QuestionMobilityMapper {
  static dtoToEntity(
    dto: QuestionMobilityDto,
  ): ImpactCo2Answer<ValuesMobility> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'MOBILITY',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        transportationMode: validateValueInType<TransportationMode>(
          dto.transportationMode,
          TransportationModeValues,
        ),
        passengerCount: Number.parseFloat(dto.passengerCount.toString()),
        travelDistance: Number.parseFloat(dto.travelDistance.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesMobility>,
    projectId: number,
  ): Omit<QuestionMobilityDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      transportationMode: answer.values.transportationMode,
      passengerCount: answer.values.passengerCount,
      travelDistance: answer.values.travelDistance,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
